import React from 'react'
import {Link} from 'react-router-dom'
import { FloatingLabel, Form, Button, Row, Container, Col } from 'react-bootstrap'
import {FaApple, FaGoogle, FaFacebookF} from 'react-icons/fa'

const styled = {border:"none", outline:"none", boxShadow:"none", width:"100%"}


function Login() {
    return (
        <Container>
            <Row className="d-flex justify-content-evenly py-5">
            <Col md={5} className='d-flex flex-column align-items-center'>
       <Form className="mt-2 d-flex align-items-center justify-content-center flex-wrap" >
       <FloatingLabel
    controlId="floatingInput"
    label="Email address"
    className="mb-3 border border-dark d-inline-block w-100"
  >
    <Form.Control 
    style={styled}type="email" placeholder="name@example.com" />
  </FloatingLabel>
  <FloatingLabel
    controlId="floatingInput"
    label="Email address"
    className="mb-3 border border-dark d-inline-block w-100"
  >
    <Form.Control 
    style={styled}type="email" placeholder="name@example.com" />
  </FloatingLabel>
  </Form>
  <Button className="w-100 py-3 mb-3" variant="secondary" type="submit">
    create account
  </Button>
                </Col>
                <Col md={5} className="d-flex flex-column align-items-center">
  <Button className="w-100 p-3 fs-5 mb-3 d-flex justify-content-evenly align-items-center" variant="secondary" >
  <FaGoogle style={{width:"30px", marginLeft:"3px"}}/> <small className='w-75 text-center'>continue with google</small>
  </Button>
    <Button className="w-100 p-3 fs-5 mb-3 d-flex justify-content-evenly align-items-center" variant="secondary" >
      <FaFacebookF style={{width:"30px", marginLeft:"3px"}}/> <small className='w-75 text-center'> continue with facebook</small>
  </Button>
  <Button className="w-100 p-3 fs-5 mb-3 d-flex justify-content-evenly align-items-center" variant="secondary" >
  <FaApple style={{width:"30px", marginLeft:"3px"}}/> <small className='w-75 text-center'>continue with apple</small>
  </Button>
      <small>don`t have account <Link className='ms-1' to='/register'>register</Link></small>
    </Col>
            </Row>
        </Container>
    )
}

export default Login
